export const getFilterFieldValues = (state: RootState) => state.filter.values
